import { render, staticRenderFns } from "./OptionModal.vue?vue&type=template&id=bd962b30&scoped=true&"
import script from "./OptionModal.vue?vue&type=script&lang=ts&"
export * from "./OptionModal.vue?vue&type=script&lang=ts&"
import style0 from "./OptionModal.vue?vue&type=style&index=0&id=bd962b30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd962b30",
  null
  
)

export default component.exports